/* eslint-disable prefer-destructuring */
/* eslint-disable camelcase */
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { compose, bindActionCreators as bind } from 'redux';

import Picker from '../components/DiagnosticFlow/Picker';

import DiagnosticFlow from '../components/DiagnosticFlow/Flow';

import { Diagnostic } from '../data/ducks';
import { getUserAgeFromGoal, getUserSavingsFromGoal, mp, getCampaign } from '../constants/utils';
import {
  // Credit picker
  creditCard,
  otherCredit,
  studentCredit,
  mortgageCredit,
  carCredit,
  personalCredit,
  // Experiences
  carExp,
  propExp,
  vacExp,
  wedExp,
  gradExp,
  remodExp,
  charExp,
  otherExp,
  // Savings
  debitSavings,
  investmentSavings,
  vaultSavings,
  planSavings,
  aforeSavings,
  // Other stuff
  personalInfo,
  expenses,
  insurance,
  dummyBudget,
} from '../constants/questionnaires';
import TempResult from '../components/DiagnosticFlow/TempResult';
import Loading from '../components/ResultCreator/Loading';

// Los steps ya no solo son flows,
// Tambien tienen nombre - que pasamos a los flows
// y también tienen la propiedad de hasbeensubmitted
const DiagnosticSteps = [
  // Step #1: Sobre ti
  {
    flow: DiagnosticFlow,
    title: 'Sobre ti',
    hasBeenSubmitted: false,
    mixpanel: () => {
      mp(`[${getCampaign(window.location.href)}] | Diagnostic | Form | Sobre ti`);
    },
  },
  // Step #2: Tus deudas
  {
    flow: Picker,
    title: 'Deudas',
    hasBeenSubmitted: false,
    mixpanel: () => {
      mp(`[${getCampaign(window.location.href)}] | Diagnostic | Form | Deudas picker`);
    },
    pickerTitle: 'Selecciona todos los créditos que tengas...',
    pickerOptOut: 'No tengo ningún crédito',
    pickerOptions: [
      {
        label: 'Tarjeta de crédito',
        hotkey: 'A',
        value: 'credit_card',
        questions: [...creditCard],
        icon: 'creditCard',
        dimensions: 35,
      },
      {
        label: 'Crédito automotriz',
        hotkey: 'B',
        value: 'car_credit',
        questions: [...carCredit],
        dimensions: 40,
        icon: 'carCredit',
      },
      {
        label: 'Crédito hipotecario',
        hotkey: 'C',
        value: 'mortgage_credit',
        icon: 'mortgageCredit',
        questions: [...mortgageCredit],
        dimensions: 50,
      },
      {
        label: 'Crédito personal',
        hotkey: 'D',
        value: 'personal_credit',
        icon: 'personalCredit',
        questions: [...personalCredit],
        dimensions: 50,
      },
      {
        label: 'Crédito estudiantil',
        hotkey: 'E',
        value: 'student_credit',
        icon: 'studentCredit',
        questions: [...studentCredit],
        dimensions: 40,
      },
    ],
  },
  // Step #2: Tus deudas -> TODO: SEGURIDAD
  {
    flow: DiagnosticFlow,
    title: 'Deudas',
    hasBeenSubmitted: false,
    mixpanel: () => {
      mp(`[${getCampaign(window.location.href)}] | Diagnostic | Form | Deudas`);
    },
  },
  // Step #3: Seguridad
  {
    flow: DiagnosticFlow,
    title: 'Seguridad',
    hasBeenSubmitted: false,
    mixpanel: () => {
      mp(`[${getCampaign(window.location.href)}] | Diagnostic | Form | Seguridad`);
    },
  },
  // Step #4: Ingresos y gastos
  {
    flow: DiagnosticFlow,
    title: 'Ingresos y gastos',
    hasBeenSubmitted: false,
    mixpanel: () => {
      mp(`[${getCampaign(window.location.href)}] | Diagnostic | Form | Ingresos y gastos`);
    },
  },
  // Step #5: Ahorro
  {
    flow: Picker,
    title: 'Ahorro',
    hasBeenSubmitted: false,
    mixpanel: () => {
      mp(`[${getCampaign(window.location.href)}] | Diagnostic | Form | Picker de ahorro`);
    },
    pickerTitle: '¿Dónde ahorras?',
    pickerOptOut: 'No ahorro',
    pickerOptions: [
      {
        label: 'Cuenta de débito/nómina',
        hotkey: 'A',
        value: 'debit_savings',
        questions: [...debitSavings],
        icon: 'debitCard',
        dimensions: 40,
      },
      {
        label: 'Cuenta de inversión',
        hotkey: 'B',
        value: 'investment_savings',
        icon: 'investmentAccount',
        questions: [...investmentSavings],
        dimensions: 40,
      },
      {
        label: 'Caja de ahorro',
        hotkey: 'C',
        icon: 'cajaDeAhorro',
        value: 'vault_savings',
        questions: [...vaultSavings],
        dimensions: 50,
      },
      {
        label: 'Plan personal de retiro',
        hotkey: 'D',
        value: 'plan_savings',
        icon: 'personalPlan',
        questions: [...planSavings],
        dimensions: 40,
      },
      {
        label: 'Afore',
        hotkey: 'E',
        value: 'afore_savings',
        icon: 'afore',
        questions: [...aforeSavings],
        dimensions: 60,
      },
    ],
  },
  // Step #5: Ahorro
  {
    flow: DiagnosticFlow,
    title: 'Ahorro',
    hasBeenSubmitted: false,
    mixpanel: () => {
      mp(`[${getCampaign(window.location.href)}] | Diagnostic | Form | Form de ahorro`);
    },
  },
  // Step #6: Metas
  {
    flow: Picker,
    title: 'Metas',
    hasBeenSubmitted: false,
    mixpanel: () => {
      mp(`[${getCampaign(window.location.href)}] | Diagnostic | Form | Picker de metas`);
    },
    pickerTitle: '¿Para qué metas te gustaría ahorrar?',
    pickerOptOut: 'Ninguna',
    pickerOptions: [
      {
        label: 'Comprar un auto',
        hotkey: 'A',
        value: 'car_exp',
        questions: [...carExp],
        icon: 'carCredit',
        dimensions: 40,
      },
      {
        label: 'Enganche de propiedad',
        hotkey: 'B',
        value: 'prop_exp',
        questions: [...propExp],
        dimensions: 40,
        icon: 'property',
      },
      {
        label: 'Vacaciones de ensueño',
        hotkey: 'C',
        value: 'vac_exp',
        questions: [...vacExp],
        dimensions: 40,
        icon: 'vacations',
      },
      {
        label: 'Boda',
        hotkey: 'D',
        value: 'wed_exp',
        questions: [...wedExp],
        dimensions: 35,
        icon: 'wedding',
      },
      {
        label: 'Posgrado',
        hotkey: 'E',
        value: 'grad_exp',
        questions: [...gradExp],
        dimensions: 35,
        icon: 'gradDegree',
      },
      {
        label: 'Renovar propiedad',
        hotkey: 'F',
        value: 'remod_exp',
        questions: [...remodExp],
        icon: 'remodelling',
        dimensions: 40,
      },
      {
        label: 'Donar a una causa',
        hotkey: 'G',
        value: 'char_exp',
        questions: [...charExp],
        icon: 'charity',
        dimensions: 40,
      },
      {
        label: 'Otra experiencia',
        hotkey: 'H',
        value: 'other_exp',
        icon: 'add',
        questions: [...otherExp],
        dimensions: 40,
      },
    ],
  },
  // Step #6: Metas
  {
    flow: DiagnosticFlow,
    title: 'Metas',
    hasBeenSubmitted: false,
    mixpanel: () => {
      mp(`[${getCampaign(window.location.href)}] | Diagnostic | Form | Form de metas`);
    },
  },
];

// First section
const personalInfoQuestionnaire = [
  {
    label: '',
    value: 'personal_info',
    totalQuestions: personalInfo.length,
    questions: personalInfo,
  },
];
// Al inicializar questionnaires - así los he declarado
const expensesQuestionnaire = [
  {
    label: '',
    value: 'expenses',
    totalQuestions: expenses.length,
    questions: expenses,
  },
];

const insuranceQuestionnaire = [
  {
    label: '',
    value: 'insurance',
    totalQuestions: insurance.length,
    questions: [...insurance],
  },
];

const stepQuestionnaires = [personalInfoQuestionnaire];

function getMonthlyExpenseBiMo(biweekly, monthly) {
  return monthly || biweekly * 2;
}

function getMonthlyExpenseMoAn(monthly, annual) {
  return monthly || annual / 2;
}

class DiagnosticContainer extends Component {
  state = {
    // Aquí se guardan los resulados por cada sección
    answeredSoFar: [],
    currentStep: 0,
    totalSteps: DiagnosticSteps.length + 1,
    totalMacroSteps: 6,
    macroStepCount: 1,
    loading: false,
    globalExpenses: 0,
    globalIncome: 0,
    incomeSet: false,
    expenseMap: [],
    expenseBySection: {},
  };

  componentWillMount = () => {
    this.setState({
      // Inicialización del primer cuestionario
      questionnaire: personalInfoQuestionnaire,
    });
  };

  componentDidMount() {
    // console.log(process.env);
    if (this.props.match.params.step) {
      // console.log('params');
      // console.log(this.props.match.params);
      this.loadAnswers(this.props.match.params.step);
    }
  }

  componentWillReceiveProps(nextProps) {
    // console.log('NEXTPROPS');
    // console.log(nextProps);
    if (!nextProps.result) {
      mp(`[${getCampaign(window.location.href)}] | Diagnostic | Error | Unknown`);
    } else if (nextProps.result.data.incomeOverflow) {
      mp(`[${getCampaign(window.location.href)}] | Diagnostic | Error | Income Overflow`);
      const {
        expensesTotal,
        insurancePayment,
        creditPayment,
        savingsPayment,
        totalIncome,
      } = nextProps.result.data;
      this.setState({
        answeredSoFar: {
          expensesTotal,
          insurancePayment,
          creditPayment,
          savingsPayment,
          totalIncome,
        },
      });
      DiagnosticSteps.push({
        flow: TempResult,
        title: 'Resultado',
        hasBeenSubmitted: false,
      });
      this.nextStep();
    } else {
      mp(`[${getCampaign(window.location.href)}] | Diagnostic | Success`);
      this.props.history.push(`/plan/res/${nextProps.result.data.uuid}`);
    }
  }

  setGlobalExpenses = (exp, sectionNumber, expenseMap) => {
    const { globalExpenses, expenseBySection } = this.state;
    const previousVal = expenseBySection[sectionNumber] || 0;
    const newExpenseBySection = { ...expenseBySection };
    newExpenseBySection[sectionNumber] = exp;
    this.setState({
      globalExpenses: exp - previousVal,
      expenseBySection: newExpenseBySection,
      expenseMap,
    });
  };

  setGlobalIncome = (income) => {
    this.setState({ globalIncome: income, incomeSet: true });
  };

  loadAnswers = (step) => {
    step = parseInt(step);
    let currStep = 0;
    while (currStep < step) {
      const stepAnswers = localStorage.getItem(`step${currStep}`);
      if (typeof stepAnswers === 'undefined') return false;
      const ansObj = JSON.parse(stepAnswers);
      // console.log('obj');
      // console.log(ansObj);
      currStep++;
    }
    return true;
  };

  // Estas tres funciones hacen la magia de que el usuario no pueda
  // dar reload o back accidental
  /*

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.handleLeavePage);
  }

  handleLeavePage = (e) => {
    const { currentStep } = this.state;
    const confirmationMessage = '';
    // Primera y última pantalla si pueden hacer reload y back sin pedos...
    // TODO: Update el index de la ultima pantalla porque no será 5
    if (currentStep !== 9 && currentStep !== 0) {
      e.returnValue = confirmationMessage;
    }
    return confirmationMessage;
  }
  */

  // TODO: Cerciorarnos que no se usa, borrar...
  setUserPlan = (goals) => {
    // eslint-disable-next-line
    const { age } = getUserAgeFromGoal(goals[0]);
    // eslint-disable-next-line
    const { current_savings } = getUserSavingsFromGoal(goals[goals.length - 1]);
    return {
      age,
      current_savings,
      financial_goals: goals,
    };
  };

  // MacroStepCount es lo que se modifica con estas dos funciones...
  // MacroStepCount es lo que representa las secciones. "Ya se acabo la sección"

  // currentStep representa el index literal de los steps definidos anteriormente...
  incrementStepCounter = () => {
    const { currentStep } = this.state;
    // Ya acabamos esta sección
    DiagnosticSteps[currentStep].hasBeenSubmitted = true;
    this.setState((state) => ({ macroStepCount: state.macroStepCount + 1 }));
  };

  goBack = (macroSteps, currentSteps, cb) => {
    this.setState((state) => {
      const macroStepCount = state.macroStepCount - macroSteps;
      const currentStep = state.currentStep - currentSteps;
      const expenseBySection = state.expenseBySection;
      expenseBySection[macroStepCount] = 0;
      const globalExpenses = expenseBySection[macroStepCount - 1] || 0;
      let globalIncome = state.globalIncome;
      if (state.macroStepCount === 4) {
        globalIncome = 0;
      }
      return {
        macroStepCount,
        currentStep,
        expenseBySection,
        globalExpenses,
        globalIncome,
      };
    }, cb);
  };

  decrementStepCounter = () => {
    this.setState((state) => ({ macroStepCount: state.macroStepCount - 1 }));
  };

  // Utilizado para regresar en FlowHeader...
  prevStep = () => {
    const { currentStep } = this.state;
    if (currentStep > 0) {
      this.setState((state) => ({ currentStep: state.currentStep - 1 }));
    }
  };

  nextStep = () => {
    const { currentStep, totalSteps } = this.state;
    if (currentStep < totalSteps - 1) {
      this.setState((state) => ({ currentStep: state.currentStep + 1 }));
    }
  };

  // Sólo se usa cuando el usuario haya ingresado datos...
  // Primera vez que lo manda
  // Tambien: Cuando edita los datos y los queremos volver a mandar
  handleGoForward = () => {
    this.incrementStepCounter();
    this.nextStep();
  };

  handleGoBack = (cb) => {
    const { currentStep, answeredSoFar } = this.state;
    DiagnosticSteps[currentStep - 1].hasBeenSubmitted = false;
    switch (currentStep) {
      // In picker, going back to Step #1: Sobre ti
      case 1:
        this.setState(
          {
            questionnaire: personalInfoQuestionnaire,
          },
          () => {
            this.goBack(1, 1, cb);
          },
        );
        break;
      // Filling out details from picker's chosen debt, going back to picker
      case 2:
        this.setState(
          (prevState) => {
            const expenseMap = prevState.expenseMap;
            expenseMap[prevState.macroStepCount - 1] = {};
            return {
              expenseMap,
              answeredSoFar: {
                ...answeredSoFar,
                credits: {
                  data: {},
                },
              },
              questionnaire: [],
            };
          },
          () => {
            this.goBack(0, 1, cb);
          },
        );
        break;
      // On security, going back to picker
      case 3:
        this.setState(
          (prevState) => {
            const expenseMap = prevState.expenseMap;
            expenseMap[prevState.macroStepCount - 1] = {};
            return {
              expenseMap,
              questionnaire: [],
              answeredSoFar: {
                ...answeredSoFar,
                credits: {
                  data: {},
                },
                globalExpenses: 0,
                expenseMap: {},
              },
            };
          },
          () => {
            this.goBack(1, 2, cb);
          },
        );
        break;
      // On ingresos y gastos, going back to security
      case 4:
        this.setState(
          (prevState) => {
            const expenseMap = prevState.expenseMap;
            expenseMap[prevState.macroStepCount - 1] = {};
            return {
              expenseMap,
              // inicializar segundo questionnaire: gastos
              questionnaire: insuranceQuestionnaire,
              answeredSoFar: {
                ...answeredSoFar,
                insurance: {
                  data: {},
                },
              },
            };
          },
          () => {
            this.goBack(1, 1, cb);
          },
        );
        break;
      // On ahorro picker, going back to Step #3: Ingresos y gastos
      case 5:
        this.setState(
          (prevState) => {
            const expenseMap = prevState.expenseMap;
            expenseMap[prevState.macroStepCount - 1] = {};
            return {
              expenseMap,
              answeredSoFar: {
                ...answeredSoFar,
                expenses: {
                  data: {},
                },
              },
            };
          },
          () => {
            this.goBack(1, 1, cb);
          },
        );
        break;
      // On ahorro's selected ones flow, going back to ahorro picker
      case 6:
        this.setState(
          (prevState) => {
            const expenseMap = prevState.expenseMap;
            expenseMap[prevState.macroStepCount - 1] = {};
            return {
              expenseMap,
              answeredSoFar: {
                ...answeredSoFar,
                savings: {
                  data: [{}],
                },
              },
            };
          },
          () => {
            this.goBack(0, 1, cb);
          },
        );
        break;
      // On goals picker, going back to ahorro picker
      case 7:
        this.setState(
          (prevState) => {
            const expenseMap = prevState.expenseMap;
            expenseMap[prevState.macroStepCount - 1] = {};
            return {
              expenseMap,
              answeredSoFar: {
                ...answeredSoFar,
                savings: {
                  data: {},
                },
              },
            };
          },
          () => {
            this.goBack(1, 2, cb);
          },
        );
        break;
      // On goals selected ones, going back to goals picker
      case 8:
        this.setState(
          (prevState) => {
            const expenseMap = prevState.expenseMap;
            expenseMap[prevState.macroStepCount - 1] = {};
            return {
              expenseMap,
              answeredSoFar: {
                ...answeredSoFar,
                experiences: {
                  data: [{}],
                },
              },
            };
          },
          () => {
            this.goBack(0, 1, cb);
          },
        );
        break;
      default:
        break;
    }
  };

  handleStepSubmit = (data) => {
    const { currentStep, answeredSoFar, macroStepCount } = this.state;
    switch (currentStep) {
      // Submission of Step #1: Sobre ti
      case 0:
        // pasar a Picker
        this.setState(
          {
            answeredSoFar: {
              ...answeredSoFar,
              personalInfo: {
                data: data[0],
              },
            },
            questionnaire: [],
          },
          () => {
            localStorage.setItem(
              'step0',
              JSON.stringify({ personalInfo: { data: data[0] }, name: 'personalInfo' }),
            );
            this.handleGoForward();
          },
        );
        break;
      // User chose from Step #2: Deudas
      case 1:
        if (data.goals.length === 0) {
          this.setState(
            (prevState) => {
              const expenseBySection = prevState.expenseBySection;
              expenseBySection[macroStepCount] = expenseBySection[macroStepCount - 1];
              return {
                answeredSoFar: {
                  ...answeredSoFar,
                  credits: {
                    data: {},
                  },
                },
                expenseBySection,
                questionnaire: insuranceQuestionnaire,
              };
            },
            () => {
              localStorage.setItem('1', { credits: { data: {} }, name: 'credits' });
              this.nextStep();
              this.handleGoForward();
            },
          );
        } else {
          this.setState(
            {
              questionnaire: [...data.goals],
            },
            () => {
              this.nextStep();
            },
          );
        }
        break;
      // Submission of Step #2: Deudas -> TODO: SEGURIDAD
      case 2:
        this.setState(
          {
            // inicializar segundo questionnaire: gastos
            questionnaire: insuranceQuestionnaire,
            // TODO: Generar variable extra que represente diferencia entre ingreso y gasto...
            // Esta variable la usaremos para desplegar un chequeo o no al final de la última sección
            answeredSoFar: {
              ...answeredSoFar,
              credits: {
                data,
              },
            },
          },
          () => {
            localStorage.setItem('1', { credits: { data }, name: 'credits' });
            this.handleGoForward();
          },
        );
        break;
      case 3:
        this.setState(
          {
            // inicializar segundo questionnaire: gastos
            questionnaire: expensesQuestionnaire,
            // TODO: Generar variable extra que represente diferencia entre ingreso y gasto...
            // Esta variable la usaremos para desplegar un chequeo o no al final de la última sección
            answeredSoFar: {
              ...answeredSoFar,
              insurance: {
                data: data[0],
              },
            },
          },
          () => {
            localStorage.setItem('2', { insurance: { data: data[0] }, name: 'insurance' });
            this.handleGoForward();
          },
        );
        break;
      // Submission of Step #3: Ingresos y gastos
      case 4:
        this.setState(
          {
            answeredSoFar: {
              ...answeredSoFar,
              expenses: {
                data,
              },
            },
          },
          () => {
            localStorage.setItem('3', { expenses: { data }, name: 'expenses' });
            this.handleGoForward();
          },
        );
        break;
      // User chose from Step #4: Ahorro
      case 5:
        if (data.goals.length === 0) {
          this.setState(
            (prevState) => {
              const expenseBySection = prevState.expenseBySection;
              expenseBySection[macroStepCount] = expenseBySection[macroStepCount - 1];
              return {
                answeredSoFar: {
                  ...answeredSoFar,
                  savings: {
                    data: [{}],
                  },
                },
                expenseBySection,
              };
            },
            () => {
              localStorage.setItem('4', { savings: { data: [{}] }, name: 'savings' });
              this.nextStep();
              this.handleGoForward();
            },
          );
        } else {
          this.setState(
            {
              questionnaire: [...data.goals],
            },
            () => {
              this.nextStep();
            },
          );
        }
        break;
      // Submission of Step #4: Ahorro
      case 6:
        this.setState(
          {
            answeredSoFar: {
              ...answeredSoFar,
              savings: {
                data,
              },
            },
          },
          () => {
            localStorage.setItem('4', { savings: { data }, name: 'savings' });
            this.handleGoForward();
          },
        );
        break;
      // User chose from Step #5: Metas
      case 7:
        if (data.goals.length === 0) {
          this.setState(
            (prevState) => {
              const expenseBySection = prevState.expenseBySection;
              expenseBySection[macroStepCount] = expenseBySection[macroStepCount - 1];
              return {
                answeredSoFar: {
                  ...answeredSoFar,
                  experiences: {
                    data: [{}],
                  },
                },
                expenseBySection,
              };
            },
            () => {
              localStorage.setItem('5', { experiences: { data: [{}] }, name: 'experiences' });
              DiagnosticSteps.pop();
              DiagnosticSteps.push({
                flow: Loading,
                title: 'Resultado',
                hasBeenSubmitted: false,
              });
              this.nextStep();
            },
          );
        } else {
          this.setState(
            {
              questionnaire: [...data.goals],
            },
            () => {
              this.nextStep();
            },
          );
        }
        break;
      // Submission of Step #5: Metas
      case 8:
        this.setState(
          {
            answeredSoFar: {
              ...answeredSoFar,
              experiences: {
                data,
              },
            },
            questionnaire: [],
          },
          () => {
            localStorage.setItem('5', { experiences: { data }, name: 'experiences' });
            this.setState(
              {
                answeredSoFar: {
                  ...answeredSoFar,
                  experiences: {
                    data,
                  },
                },
              },
              () => {
                DiagnosticSteps.push({
                  flow: Loading,
                  title: 'Resultado',
                  hasBeenSubmitted: false,
                });
                this.nextStep();
              },
            );
          },
        );
        break;
      default:
        break;
    }
  };

  render() {
    const {
      currentStep,
      questionnaire,
      answeredSoFar,
      macroStepCount,
      incomeSet,
      totalMacroSteps,
      loading,
      globalExpenses,
      globalIncome,
      expenseMap,
    } = this.state;
    const { plan } = this.props;
    const CurrentStep = DiagnosticSteps[currentStep].flow;
    return (
      <Fragment>
        <CurrentStep
          title={DiagnosticSteps[currentStep].title}
          numberOfSteps={totalMacroSteps}
          macroStep={macroStepCount}
          goBack={this.handleGoBack}
          goForward={this.handleGoForward}
          nextStep={this.nextStep}
          onStepSubmit={this.handleStepSubmit}
          questionnaire={questionnaire}
          plan={plan}
          hasBeenSubmitted={DiagnosticSteps[currentStep].hasBeenSubmitted}
          injectNewQuestions={this.injectNewQuestions}
          answeredSoFar={answeredSoFar}
          previousTitle={
            DiagnosticSteps[currentStep - 1] &&
            (DiagnosticSteps[currentStep - 1].title ||
              DiagnosticSteps[currentStep - 1].pickerTitle ||
              '')
          }
          pickerTitle={DiagnosticSteps[currentStep].pickerTitle}
          pickerOptOut={DiagnosticSteps[currentStep].pickerOptOut}
          pickerOptions={DiagnosticSteps[currentStep].pickerOptions}
          mixpanel={DiagnosticSteps[currentStep].mixpanel}
          setGlobalExpenses={this.setGlobalExpenses}
          globalExpenses={globalExpenses}
          globalIncome={globalIncome}
          incomeSet={incomeSet}
          setGlobalIncome={this.setGlobalIncome}
          expenseMap={expenseMap}
          currentStep={currentStep}
        />
      </Fragment>
    );
  }
}

DiagnosticContainer.propTypes = {
  plan: PropTypes.object,
  result: PropTypes.object,
  saveDiagnosticData: PropTypes.func,
};

DiagnosticContainer.defaultProps = {
  plan: {},
  result: {},
  saveDiagnosticData: () => {},
};

const mapStateToProps = (state) => ({
  plan: state.goals.plan,
  result: state.diagnostic.result,
  // someData: Diagnostic.Selectors.getData(state), // INFO:
});

const mapDispatchToProps = (dispatch) =>
  bind(
    {
      saveDiagnosticData: Diagnostic.Creators.saveDiagnosticDataRequested,
    },
    dispatch,
  );

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
)(DiagnosticContainer);
